export {type IconPropsWithoutChildren} from '../../../src/icon/Icon';
